import React from 'react';
import CortexToolsPost from './CortexToolsPost';
import UpdatesIndex from './UpdatesIndex';
import SnowflakeSoFarPost from './SnowflakeSoFarPost';
import FabricMirroringPost from './FabricMirroringPost';
import BehaviorBundlesPost from './BehaviorBundlesPost';
import GovernanceByDefaultPost from './GovernanceByDefaultPost';
import OssiePost from './OssiePost';
import SqlAlchemyUpgradePost from './SqlAlchemyUpgradePost';
import CortexGatewayAzurePost from './CortexGatewayAzurePost';

export const updateRoutes = [
  { path: '/updates', element: <UpdatesIndex /> },
  { path: '/updates/snowflake-cortex-tools-governed-agents', element: <CortexToolsPost /> },
  { path: '/updates/snowflake-2026-so-far', element: <SnowflakeSoFarPost /> },
  {
    path: '/updates/snowflake-microsoft-fabric-mirroring-vs-iceberg',
    element: <FabricMirroringPost />,
  },
  { path: '/updates/behavior-change-bundles', element: <BehaviorBundlesPost /> },
  { path: '/updates/snowflake-governance-by-default', element: <GovernanceByDefaultPost /> },
  { path: '/updates/ossie-semantic-view-interchange', element: <OssiePost /> },
  {
    path: '/updates/snowflake-sqlalchemy-2-upgrade-checklist',
    element: <SqlAlchemyUpgradePost />,
  },
  { path: '/updates/cortex-ai-gateway-azure', element: <CortexGatewayAzurePost /> },
];
